import { Select_, Form, Button, SuccessNotification } from "components/common";
import React, { useEffect, useState } from "react";
import { callPostApiWithAuth } from "utils/api";
import { Wrapper } from "./DeleteCategoryModal.styled";

const DeleteCategoryModal = ({
  expenseData,
  expenseId,
  setIsDeleteModal,
  callGetExpenseApi,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [newID, setNewId] = useState(false);

  const onDeleteSuccessCall = () => {
    SuccessNotification("Expense Category Deleted");
    setIsDeleteModal(false);
    callGetExpenseApi();
    setIsLoading(false);
  };

  const onDeleteFailCall = (err) => {
    console.log(err);
    setIsLoading(false);
  };
  const DeleteExpense = () => {
    setIsLoading(true);
    callPostApiWithAuth(
      `deleteExpenseCategory`,
      {
        newCategoryId: newID,
        categoryId: expenseId,
      },
      onDeleteSuccessCall,
      onDeleteFailCall
    );
  };
  useEffect(() => {
    if (expenseId) {
      setNewId(expenseId);
    }
  }, [expenseId]);

  return (
    <Wrapper>
      <Form name="basic" autoComplete="off">
        <Form.Item
          name="name"
          rules={[
            {
              required: true,
              message: "please Select the Filed",
            },
          ]}
        >
          <Select_
            name
            options={expenseData}
            value={newID}
            placeholder="Category"
            onChange={(e) => {
              setNewId(e);
            }}
          />
        </Form.Item>
        <Form.Item className="submit-form-container">
          <Button title="Submit" onClick={DeleteExpense} loading={isLoading} />
        </Form.Item>
      </Form>
    </Wrapper>
  );
};

export default DeleteCategoryModal;
